import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { TransactionUserType } from '@frontend/transaction/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ID = 'transaction-user-type-select';

export const TRANSACTION_USER_TYPE_SELECT_OPTIONS = [
    {
        value: TransactionUserType.RECEIVER,
        label: TransactionUserType.RECEIVER,
        display: CommonMessage.OBJECTS.TRANSACTION.RECEIVER
    },
    {
        value: TransactionUserType.SENDER,
        label: TransactionUserType.SENDER,
        display: CommonMessage.OBJECTS.TRANSACTION.SENDER
    },
    {
        value: TransactionUserType.REMOVER,
        label: TransactionUserType.REMOVER,
        display: (
            <FormattedMessage
                id='Objects.TRANSACTION.REMOVER'
                description='Label for the transaction user type remover'
                defaultMessage='Remover'
            />
        )
    }
];

export interface TransactionUserTypeSelectProps extends Omit<SelectInputV2Props<TransactionUserType>, 'options' | 'onSelect'> {
    onSelect?: (value: TransactionUserType | null) => void;
}

export const TransactionUserTypeSelect = (props: TransactionUserTypeSelectProps) => {
    const { onSelect, ...rest } = props;

    return (
        <SelectInputV2<TransactionUserType>
            {...rest}
            id={props.id || ID}
            options={TRANSACTION_USER_TYPE_SELECT_OPTIONS}
            disableSearch={props.disableSearch ?? true}
            onSelect={(option) => onSelect?.(option ? (option.value as TransactionUserType) : null)}
        />
    );
};
